"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetRatingTemplateDetail = void 0;
const react_query_1 = require("react-query");
const RatingTemplateClient_1 = require("client/admin/RatingTemplateClient");
const ratingTemplateKeys_1 = __importDefault(require("consts/queryKeys/ratingTemplateKeys"));
const useGetRatingTemplateDetail = (id, options) => {
    const fetchRatingTemplateDetail = (id) => {
        return (0, RatingTemplateClient_1.getRatingTemplateDetail)(id);
    };
    return (0, react_query_1.useQuery)(ratingTemplateKeys_1.default.ratingTemplateDetail(id), () => fetchRatingTemplateDetail(id), options);
};
exports.useGetRatingTemplateDetail = useGetRatingTemplateDetail;
